import { Label } from '@cian/ui-kit';

interface INewbuidlingRatingProps {
  promoName: string;
  promoUrl: string;
}

export function NewbuildingTag(props: INewbuidlingRatingProps) {
  const { promoName, promoUrl } = props;

  return (
    <a data-testid="newbuilding-promo" href={promoUrl} target="_blank" rel="noreferrer">
      <Label color="text-positive-default" background="accent-positive-secondary">
        {promoName}
      </Label>
    </a>
  );
}
